import React from 'react';
import { Grid, TextField, MenuItem, Autocomplete } from '@mui/material';
import { surgeryProcedureOptions, anesthesiaOptions } from '../constants/options';

const PatientInfo = ({ formData, setFormData, errors, setErrors, handleInputChange, handleBlur }) => {
  const handleNameChange = (e) => {
    const regex = /^[a-zA-Z\s.-]*$/;
    const { name, value } = e.target;
    if (value === '' || regex.test(value)) {
      setFormData(prev => ({ ...prev, [name]: value }));
      if (errors[name]) {
        setErrors((prev) => ({ ...prev, [name]: '' }));
      }
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Patient Name"
          name="patient_name"
          InputProps={{ readOnly: true }}
          value={formData.patient_name || ''}
          onChange={handleNameChange}
          required
          fullWidth
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <TextField
          label="Age"
          name="age"
          type="number"
          InputProps={{ readOnly: true }}
          value={formData.age || ''}
          onChange={handleInputChange}
          required
          fullWidth
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <TextField
          select
          label="Gender"
          name="gender"
          value={formData.gender || ''}
          onChange={handleInputChange}
          required
          InputProps={{ readOnly: true }}
          fullWidth
        >
          <MenuItem value="Male">Male</MenuItem>
          <MenuItem value="Female">Female</MenuItem>
          <MenuItem value="Other">Other</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label="UHID"
          name="uhid_no"
          value={formData.uhid_no || ''}
          onChange={handleInputChange}
          required
          fullWidth
          InputProps={{ readOnly: true }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Autocomplete
          freeSolo
          options={surgeryProcedureOptions}
          value={formData.surgery_procedure || ""}
          onInputChange={(event, newValue) => {
            setFormData(prev => ({ ...prev, surgery_procedure: newValue }));
            if (errors.surgery_procedure) setErrors(prev => ({ ...prev, surgery_procedure: "" }));
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Surgery/Procedure Done"
              name="surgery_procedure"
              required
              fullWidth
              error={!!errors.surgery_procedure}
              helperText={errors.surgery_procedure}
              onBlur={handleBlur}
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          freeSolo
          options={anesthesiaOptions}
          value={formData.anaesthesia || ""}
          onInputChange={(event, newValue) => {
            setFormData(prev => ({ ...prev, anaesthesia: newValue }));
            if (errors.anaesthesia) setErrors(prev => ({ ...prev, anaesthesia: "" }));
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Anesthesia"
              name="anaesthesia"
              required
              fullWidth
              error={!!errors.anaesthesia}
              helperText={errors.anaesthesia}
              onBlur={handleBlur}
            />
          )}
        />
      </Grid>
    </Grid>
  );
};

export default PatientInfo;
